export function formatExemplarCode(code) {
    return 'BIB-' + code.padStart(4, '0')
}
